export const isNumber = (
  value: unknown,
  opts?: { positive: boolean }
): value is number => {
  return (
    typeof value === "number" &&
    !isNaN(value) &&
    (!opts?.positive || (opts.positive && value > 0))
  );
};
